import {Component, Input} from '@angular/core';

@Component({
  selector: '[ideals-default-bg]',
  templateUrl: './default-bg.component.html',
  styleUrls: ['./default-bg.component.scss']
})
export class DefaultBgComponent {
  @Input()
  public defaultBackgroundClass = '';
}
